document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", initializeApp)
  : initializeApp();

function initializeApp() {
  initializeTabs();
  initializeModals();
}

function initializeTabs() {
  const tabs = document.querySelectorAll(".tab-nav__link");
  if (!tabs.length) return;

  const hash = window.location.hash;
  if (hash) {
    document.querySelector(hash)?.classList.add("is-active");
    document.querySelector(hash.replace("#", "."))?.classList.add("is-active");
  } else {
    tabs[0].classList.add("is-active");
    document.querySelector(".tab-item")?.classList.add("is-active");
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", (event) => {
      event.preventDefault();

      document
        .querySelectorAll(".is-active")
        .forEach((el) => el.classList.remove("is-active"));

      const clickedTab = event.target;
      clickedTab.classList.add("is-active");

      const menuSelector = clickedTab.dataset.tab;
      document.querySelector(menuSelector)?.classList.add("is-active");
    });
  });
}

function initializeModals() {
  const thumbnails = document.querySelectorAll(".thumbnail");

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => {
      const modal = document.getElementById(thumbnail.dataset.modal);
      if (!modal) return;

      const closeBtn = modal.querySelector(".close");
      modal.style.display = "block";

      const closeModal = () => {
        modal.style.display = "none";
        window.removeEventListener("click", handleWindowClick);
      };

      const handleWindowClick = (event) => {
        if (
          !event.target.classList.contains("thumbnail") &&
          !event.target.classList.contains("modal-image")
        ) {
          closeModal();
        }
      };

      closeBtn?.addEventListener("click", closeModal);

      window.addEventListener("click", handleWindowClick);
    });
  });
}
